import { Component } from "@angular/core";
import { SettingsService } from "../../core/settings/settings.service";
import { TranslatePipe } from "@ngx-translate/core";
import { Router, RouterModule } from "@angular/router";

@Component({
  selector: "[app-footer]",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  imports: [TranslatePipe, RouterModule],
})
export class FooterComponent {
  constructor(
    public settings: SettingsService,
    private router: Router,
  ) {}
  NavigateToPrivacy() {
    let newRelativeUrl = this.router.createUrlTree(["/privacy"]);
    // The URL should be http://localhost:4200/#
    let baseUrl = window.location.href.replace(this.router.url, "");

    window.open(baseUrl + newRelativeUrl, "_blank");
  }
}
